import styled, { css } from 'styled-components';
import { space, position, system } from 'styled-system';
import breakpoint from '../../utils/style-utils';

const SimpleButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: ${props =>
		props.light
			? 'var(--button-wrapper-bg-light, rgba(var(--base-03), 1))'
			: 'var(--button-wrapper-bg, rgba(var(--base-03), 1))'};
	${props =>
		props.transparent &&
		css`
			background-color: transparent;
		`};
	& > button:not(:first-of-type) {
		margin-top: 1px;
	}
	${space}
	${position}
	${system({
		gap: {
			property: 'gap',
			scale: 'gaps'
		}
	})}
`;

SimpleButtonWrapper.defaultProps = {
	pl: 5,
	pr: 5,
	pt: 5,
	pb: 5,
	gap: 1
};

const ButtonWrapper = styled(SimpleButtonWrapper).attrs({
	className: 'button-wrapper'
})`
	bottom: 0;
	left: 0;
	position: ${props => (props.unset ? 'unset' : props.smallerPositionValue || 'fixed')};
	${props =>
		props.webkitSticky &&
		css`
			position: --webkit-sticky;
		`}
	z-index: 2;
	-webkit-backface-visibility: hidden;
	${breakpoint.lg`
		margin: 0 auto;
		max-width: var(--modalContentMaxWidth);
		position: ${props => (props.unset ? 'unset' : props.biggerPositionValue || 'absolute')};
		right: 0;
		${props =>
			props.inSidebar &&
			props.biggerPositionValue === 'fixed' &&
			css`
				left: calc(100% - var(--detailWidth));
				width: auto;
			`};
	`};
	.link-list {
		margin-top: 0;
		.btn {
			margin-bottom: 1px;
		}
	}
`;

export { SimpleButtonWrapper };

export default ButtonWrapper;
